// import $ from "jquery";
// $.fn.jquery will show version of jQuery in the

// Legacy LESS is now complied to CSS with the
// new build system. See the build:legacy-css script in package.json
// The old LESS files are still in the repo
// import '@/css/legacy.css'

// Import our CSS
import '@/css/app.css'
// import '@/css/legacy-theme.css'

import 'alpinejs'
import focus from '@alpinejs/focus'

Alpine.plugin(focus)

import { registerVideoPlayer } from '@morton-studio/video-player'
registerVideoPlayer()

// Import our JS files that are converted to TS from the previous build
import './category-dropdown-news.ts'
import './read-more'
import './expanded-content'
import './carousel'
import './entry-editor-links'
import './external-links-new-window'


import Alpine from 'alpinejs'
import collapse from '@alpinejs/collapse'

Alpine.plugin(collapse)

// @ts-expect-error: Alpine needs to be added to window scope
window.Alpine = Alpine
Alpine.start()


// Accept HMR as per https://vitejs.dev/guide/api-hmr.html#accepting-updates
if (import.meta.hot) {
	import.meta.hot.accept(() => {
		console.log('HMR update')
	})
}
